export default "__VITE_ASSET__DbeySC0K__"